import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { getStripeEnvironment } from "@/lib/stripe";

export function useLicense(userId: string | undefined) {
  const [hasLicense, setHasLicense] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!userId) {
      setHasLicense(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data } = await supabase
      .from("licenses")
      .select("id,status")
      .eq("user_id", userId)
      .eq("environment", getStripeEnvironment())
      .eq("status", "active")
      .order("created_at", { ascending: false })
      .limit(1)
      .maybeSingle();
    setHasLicense(!!data);
    setLoading(false);
  }, [userId]);

  useEffect(() => {
    refetch();
    if (!userId) return;
    const channel = supabase
      .channel(`licenses:${userId}:${Math.random().toString(36).slice(2)}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "licenses", filter: `user_id=eq.${userId}` },
        () => refetch(),
      )
      .subscribe();
    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId, refetch]);


  return { hasLicense, loading, refetch };
}
